import React, { memo } from "react";
import ScheduleButton from "../Components/ScheduleButton/ScheduleButton";
import { useTranslation } from "react-i18next";
import PortfolioButton from "../Components/PortfolioButton/PortfolioButton";
import { Headline, SubHeading, Blockquote, FluidContainer, TertiaryButton, ButtonsContainer, Hero, CallButton, Paragraph } from "../Components/_Common/common.styles";
import KeywordsBackground from "../Components/KeywordsBackground/KeywordsBackground";

const Landing = () => {
  const { t } = useTranslation();

  return (
    <>
      <FluidContainer>
        <KeywordsBackground />
        <Hero>
          <Headline>
            {t('mainText.headline1')} <br />
            <span>{t('mainText.headline2')}</span>
          </Headline>
          <SubHeading>
            {t('mainText.subheading')}
          </SubHeading>
          <br />
          <Paragraph>
            {t('mainText.landingParagraph')}
          </Paragraph>
          <div style={{display: 'flex', gap: '1rem'}}>
          <ScheduleButton isOn={true} />
          <CallButton as="a" href="tel:+14383931817" title="Call Us" isOn={true} $alt={true}>
            <svg
              fill="white"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
          </CallButton>
          </div>
        </Hero>
      </FluidContainer>
        <Blockquote>
          <h2>{t('mainText.offeringTitle')}</h2>
          <p>{t('mainText.offeringText')}</p>
          <q>{t('mainText.offeringText2')}</q>
          <ButtonsContainer>
            <PortfolioButton isOn={true} />
            <TertiaryButton isOn={true} role="button" title="email us">
              <a href="mailto:hello@matandessaur.me" aria-label="Send us an email">
                <svg
                  fill="var(--text-color)"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10v1.43C22 15.4 20.47 17 18.5 17c-1.19 0-2.31-.58-2.96-1.47-.9.91-2.16 1.47-3.54 1.47-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5v1.43c0 .79.71 1.57 1.5 1.57s1.5-.78 1.5-1.57V12c0-4.34-3.66-8-8-8s-8 3.66-8 8 3.66 8 8 8h5v2h-5C6.48 22 2 17.52 2 12Zm7 0c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3Z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </a>
            </TertiaryButton>
          </ButtonsContainer>
        </Blockquote>
    </>
  );
}

export default memo(Landing);